module.exports = __webpack_public_path__ + "img/arrow_left_square.2dfbf504.svg";